module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"caption":"Farmer Identifier"},"es":{"caption":"Identificará al granjero"},"sw":{"caption":"Kitambulisha Mkulima"}}')
  delete Component.options._Ctor
}
